module.exports = __webpack_public_path__ + "img/sitodiplosis-mosellana.b0eeec73.jpg";